import type { ReactNode } from 'react';

export const formatFormLabel = (label: string, required?: boolean): ReactNode => {
    if (!required) {
        return label;
    }

    return (
        <>
            {label}
            <span aria-hidden="true" className="text-alert-error">
                {' *'}
            </span>
        </>
    );
};
